import { render, staticRenderFns } from "./UpgradeAlert.vue?vue&type=template&id=50795f26"
import script from "./UpgradeAlert.vue?vue&type=script&lang=js"
export * from "./UpgradeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports